import React from 'react'

const PitchQuestionsFormView = ({ children }) => {
  return <div>{children}</div>
}

export default PitchQuestionsFormView



// WEBPACK FOOTER //
// ./src/Components/PitchQuestionsForm/component/PitchQuestionsFormView.js